export default __webpack_public_path__ + "static/media/maintainketosis@3x.680f2ded.jpg";